import axios from "axios";
import { Buffer } from 'buffer';

var username = 'user';
var password = 'pass';
const token = `${username}:${password}`;
const encodedToken = Buffer.from(token).toString('base64');


const api = axios.create({
    baseURL: 'http://200.98.82.71:70/apprat/rat_online.dll/',//'http://200.98.82.71:70/apprat/rat_online.dll/',//'http://localhost:9000/',
    headers:{
        'Accept': 'application/json',
        'Content': 'application/json',
      //  'Authorization': 'Basic '+ encodedToken
    }

});

export default api